import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import SelectField from ".";

const SelectDentiraProductFilters = ({
  procedureOptions,
  subProcedureOptions,
  materialOptions,
  procedure,
  subProcedure,
  material,
  setProcedure,
  setSubProcedure,
  setMaterial,
}) => {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <SelectField
            label="Procedure"
            value={procedure}
            onChange={(e) => setProcedure(e.target.value)}
            options={procedureOptions}
            disabled={!procedureOptions?.length}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectField
            label="Sub Procedure"
            value={subProcedure}
            onChange={(e) => setSubProcedure(e.target.value)}
            options={subProcedureOptions}
            disabled={!subProcedureOptions?.length}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectField
            label="Material"
            value={material}
            onChange={(e) => setMaterial(e.target.value)}
            options={materialOptions}
            disabled={!materialOptions?.length}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SelectDentiraProductFilters;
